import { Pipe, PipeTransform } from '@angular/core';
import { SchortTimeZones, SelectOption } from '@fleet-beat/core';
@Pipe({
  name: 'shortTzDisplayPipe',
})
export class ShortTzDisplayPipe implements PipeTransform {
  transform(timezone: string): string {
    const shortTz = SchortTimeZones.find((zone: SelectOption) => zone.value === timezone).label;
    return shortTz || '';
  }
}
